import React from 'react';
import { useTranslation } from 'react-i18next';

import type { RadarSeverity } from '../../../types/radar';
import SeverityIndicator from './SeverityIndicator';

import './_severity-badge.scss';

type SeverityBadgeProps = {
  orientation?: 'horizontal' | 'vertical';
  severity: RadarSeverity;
};

function SeverityBadge({ orientation = 'vertical', severity }: SeverityBadgeProps): JSX.Element {
  const { t } = useTranslation(['chatbot']);

  const levelKey = severity === 'high' ? 'radar_severity_high' : severity === 'medium' ? 'radar_severity_medium' : 'radar_severity_low';
  const isHorizontal = orientation === 'horizontal';
  const rootClassName = `severity-badge${isHorizontal ? ' severity-badge--horizontal' : ''}`;

  return (
    <div className={rootClassName}>
      <span className="severity-badge__label">{t('chatbot:radar_severity_label')}:</span>
      <div className="severity-badge__row">
        <SeverityIndicator severity={severity} />
        <span className={`severity-badge__level severity-badge__level--${severity}`}>{t(`chatbot:${levelKey}`)}</span>
      </div>
    </div>
  );
}

export default SeverityBadge;
